import { Background } from 'components/search/bex/enums';
import { BackgroundState } from 'components/search/bex/interfaces';

const initialBackgroundState: BackgroundState = {
  background: Background.BEACH,
};

export { initialBackgroundState };
